import { render, staticRenderFns } from "./signup-layout.vue?vue&type=template&id=6bc24be2&scoped=true&lang=pug&"
import script from "./signup-layout.vue?vue&type=script&lang=ts&"
export * from "./signup-layout.vue?vue&type=script&lang=ts&"
import style0 from "./signup-layout.vue?vue&type=style&index=0&id=6bc24be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc24be2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
